import styled from "styled-components";

export const CardsGrid = styled("div")`
  display: grid;
  gap: 16px;
  grid-auto-rows: 350px;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
`;


export const HorizontalScrollWrapper = styled('div')`
  margin: 0px -10px;
`

export const HorizontalScroll = styled('div')`
  overflow-x: scroll;
  display: flex;
  scroll-snap-type: x mandatory;
  padding: 10px;
  scroll-padding: 0 10px;

  ::-webkit-scrollbar {
    display: none;
  }

  & > * {
    scroll-snap-align: start;
    min-width: 290px;

    @media(min-width: 768px){
      min-width: 330px;
    }

    &:not(:last-child){
      margin-right: 16px;
    }
  }
`

export const Title = styled("h3")`
  margin: 0px;
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SessionCardSkeleton = styled("div")`
  background-color: #e0e4ea;
  border-radius: 14px;
`;
